import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from './assets/McLaren-logo.svg'


const _hoisted_1 = {
  key: 0,
  id: "overlay"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  width: "300",
  src: _imports_0,
  alt: "The word McLaren in white featuring a white speed mark above the 'N' and the word Applied in smaller text below."
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { id: "router-view" }
const _hoisted_5 = {
  key: 2,
  class: "cookie_banner"
}
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-9" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("We use anonymous cookies on this website to monitor and improve upon site performance. By continuing to use our site you agree to this use. You can learn more and remove these cookies at any point via our "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "/cookies",
      style: {"color":"#000"}
    }, "cookies page"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1)
const _hoisted_9 = { class: "col-sm-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressComponent = _resolveComponent("ProgressComponent")!
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_VideoComponent = _resolveComponent("VideoComponent")!
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ProgressComponent),
    _createVNode(_component_metainfo),
    _createVNode(_component_VideoComponent),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!_ctx.menuLoaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.routesLoaded)
      ? (_openBlock(), _createBlock(_component_HeaderComponent, {
          key: 0,
          menuLoaded: _ctx.menuLoaded
        }, null, 8, ["menuLoaded"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_view)
    ]),
    (_ctx.routesLoaded)
      ? (_openBlock(), _createBlock(_component_FooterComponent, {
          key: 1,
          class: _normalizeClass({ banner: _ctx.showBanner }),
          menuLoaded: _ctx.menuLoaded
        }, null, 8, ["class", "menuLoaded"]))
      : _createCommentVNode("", true),
    (_ctx.showBanner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn btn-black",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCloseBanner()))
                }, "I accept")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}